import { getRgVersions } from "./index194.js";
import { rgBriefToDto } from "@project-rouge/rg-core";
function rgBriefToDto$1(brief) {
	return rgBriefToDto({
		brief,
		versions: getRgVersions()
	});
}
export { rgBriefToDto$1 as rgBriefToDto };

//# sourceMappingURL=index202.js.map